import { render, staticRenderFns } from "./AdminUserRelationships.vue?vue&type=template&id=12851965&scoped=true&"
import script from "./AdminUserRelationships.vue?vue&type=script&lang=js&"
export * from "./AdminUserRelationships.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserRelationships.vue?vue&type=style&index=0&id=12851965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12851965",
  null
  
)

export default component.exports